
import { defineComponent } from "vue"
import AclLayout from "~/js/Layouts/Acl.vue"

// noinspection JSUnusedGlobalSymbols
export default defineComponent({
    name: "ServicesPage",
    components: { AclLayout },
    props: {
        services: {
            type: Array,
            required: true,
        },
    },
})
